import { render, staticRenderFns } from "./TaskBackNodes.vue?vue&type=template&id=51c3b6be"
import script from "./TaskBackNodes.vue?vue&type=script&lang=js"
export * from "./TaskBackNodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c3b6be')) {
      api.createRecord('51c3b6be', component.options)
    } else {
      api.reload('51c3b6be', component.options)
    }
    module.hot.accept("./TaskBackNodes.vue?vue&type=template&id=51c3b6be", function () {
      api.rerender('51c3b6be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/components/TaskBackNodes.vue"
export default component.exports